import { SubscriptionWireValue, OptionsCodes } from './types';
import { ResponsibleForUnitValue, ResponsibleForUnitValues, SubscriptionStoreValue } from 'app/area/user-profile/subscriptions/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ComplexValue } from 'app/types-shared';

export const getUniqueOptions = (value: SubscriptionStoreValue[]): SubscriptionStoreValue[] =>
  value?.reduce(
    (acc, curr) => {
      if (!acc.some(x => x.value === curr.value)) {
        acc.push(curr);
      }
      return acc;
    }, []) ?? [];

export const mapUniqueOptions = (optionsCodes: OptionsCodes): SubscriptionStoreValue[] =>
  getUniqueOptions(optionsCodes?.values?.map(item => {
    return {
      value: item.value,
      description: item.description,
      longDescription: item.longDescription,
      readOnly: item.readOnly,
      active: item.active
    };
  }));

export const mapOptionsToStore = (data: SubscriptionWireValue[]): SubscriptionStoreValue[] => (data ?? []).map(item => {
  return {
    value: item.v,
    description: item.d,
    longDescription: item.ld,
    readOnly: item.readOnly,
    active: item.active
  };
});

export const mapResponsibleForUnitToStore = (values: ResponsibleForUnitValue[]): ResponsibleForUnitValues[] => {
  const applications = values?.map(item => item.application);
  const uniqueApplications = [...new Set(applications?.map(value => applications.find(application => application?.v === value?.v)))];
  const uniqueApplicationsMapped = uniqueApplications?.map(application => ({ value: application?.v, description: application?.d }));

  return uniqueApplicationsMapped
    ?.filter(value => isDefinedIncludingZero(value.value))
    ?.map(application => ({
      ...application,
      values: values
        .filter(value => value.application?.v === application?.value)
        .map(value => ({
          value: value?.unit?.v,
          description: value?.unit?.d
        }))
    }));
};

export const mapSaveSubscriptions = (values: ComplexValue<number>[]): SubscriptionWireValue[] =>
  values?.map(item => { return { v: item.value }; });

export const unSubscribedOptions = (mergedOptions: SubscriptionStoreValue[] = [], valueItems: SubscriptionStoreValue[]) =>
  mergedOptions.filter(option => valueItems.every(item => item.value !== option.value));

export const mergeOptions = (options: SubscriptionStoreValue[] = [], valueItems: SubscriptionStoreValue[]) => {

  if (!valueItems || valueItems.length === 0 || valueItems === options) {
    return options;
  }

  const additionalOptions = valueItems.filter(i => !options.some(o => o.value === i.value));

  return additionalOptions.length === 0
    ? options
    : [
      ...options,
      ...additionalOptions
    ];
};

export const sortOptions = (valueItems: SubscriptionStoreValue[] = [], locale: string): SubscriptionStoreValue[] =>
  [...valueItems].sort((a, b) => a?.description?.localeCompare(b?.description, locale));

export const activeSubscriptions = (value: SubscriptionStoreValue[]) => value?.filter(option => !!option?.active) ?? [];
